var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fontbox"},[_c('textarea',{attrs:{"rows":"2","cols":"50","type":"text"}},[_vm._v("Hello this is a Font xyz")])])}]

export { render, staticRenderFns }